import React, { useEffect, useState } from "react";
import VideoModal from "../components/VideoModal";
import "../styles/PradeshMap.css";

function PradeshMap() {
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const [selectedVideoId, setSelectedVideoId] = useState(null);
  const [videoList, setVideoList] = useState([]);
  const [selectedPradesh, setSelectedPradesh] = useState(null);
  const [isLoadingVideos, setIsLoadingVideos] = useState(false);

  const openVideoModal = (videoId) => {
    setSelectedVideoId(videoId);
    setIsVideoModalOpen(true);
  };

  const openPradeshModal = async (pradeshName) => {
    setSelectedPradesh(pradeshName);
    setIsVideoModalOpen(true);
    setSelectedVideoId(null);
    setIsLoadingVideos(true);
    try {
      const decodedPradeshName = decodeURIComponent(pradeshName);
      const response = await fetch(
        // `http://dbphp.prabodhswamiji.in/dbihariprabodham.php?pradesh=${encodeURIComponent(decodedPradeshName)}`,
        `https://hariprabodham.org.in/api/?pradesh=${encodeURIComponent(decodedPradeshName)}`,
      );
      if (!response.ok) {
        throw new Error("Failed to fetch videos");
      }
      const data = await response.json();
      // Normalize video data
      let videos = Array.isArray(data) ? data : [];
      // Extract YouTube IDs and other info
      videos = videos.map((video) => {
        let videoId = "";
        const videoUrl = video.VideoUrl || "";

        if (videoUrl.includes("youtube.com/watch?v=")) {
          videoId = videoUrl
            .replace("https://www.youtube.com/watch?v=", "")
            .split("&")[0];
        } else {
          videoId = extractYouTubeId(videoUrl);
        }
        return {
          ...video,
          youtubeId: videoId,
          title: video.Title || "Video",
        };
      });
      setVideoList(videos);
    } catch (error) {
      setVideoList([]);
    } finally {
      setIsLoadingVideos(false);
    }
  };

  const closeVideoModal = () => {
    setIsVideoModalOpen(false);
    setSelectedVideoId(null);
    setVideoList([]);
    setSelectedPradesh(null);
    setIsLoadingVideos(false);
  };

  useEffect(() => {
    // Check if Google Maps is already loaded
    if (window.google && window.google.maps) {
      initMap();
      return;
    }

    // Set the global initMap function before loading the script
    window.initMap = initMap;

    // Load Google Maps script if not already loaded
    if (!document.querySelector('script[src*="maps.googleapis.com"]')) {
      const script = document.createElement("script");
      script.src =
        "https://maps.googleapis.com/maps/api/js?key=AIzaSyCaYk1l7L9STHEzAgamAeVcUsbrWTtdd9M&callback=initMap";
      script.async = true;
      script.defer = true;

      script.onload = () => {
        console.log("Google Maps script loaded successfully");
      };

      script.onerror = () => {
        console.error("Failed to load Google Maps script");
        showLoading(false);
      };

      document.head.appendChild(script);
    }

    const handler = (e) => {
      openPradeshModal(e.detail.pradeshName);
    };
    window.addEventListener("openPradeshModal", handler);

    return () => {
      // Cleanup: remove the global callback
      if (window.initMap) {
        delete window.initMap;
      }

      window.removeEventListener("openPradeshModal", handler);
    };
  }, []);

  return (
    <main className="pradesh-map-page themed-map-page">
      <div className="page-header">
        <h1>Pradesh Map</h1>
        <p className="header-subtitle">
          Interactive map showing all Pradesh locations and boundaries
        </p>
      </div>

      <div className="map-container">
        {/* Navigation buttons for regions/countries */}
        <div
          className="map-navigation"
          style={{
            textAlign: "center",
            marginBottom: "2rem",
            padding: "0 1rem",
          }}
        >
          <h4
            className="map-navigation-title"
            style={{
              fontSize: "1.8rem",
              color: "#333",
              marginBottom: "0.5rem",
              fontWeight: "600",
            }}
          >
            Quick Navigation
          </h4>
          <p
            style={{
              fontSize: "1.1rem",
              color: "#666",
              margin: "0 0 1.5rem 0",
            }}
          ></p>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "10px",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <button
              onClick={() => window.navigateToRegion("gujarat")}
              style={{
                background: "#28a745",
                color: "white",
                border: "none",
                padding: "10px 20px",
                borderRadius: "6px",
                cursor: "pointer",
                fontWeight: "500",
                fontSize: "14px",
                transition: "all 0.3s ease",
              }}
              onMouseOver={(e) => (e.target.style.background = "#218838")}
              onMouseOut={(e) => (e.target.style.background = "#28a745")}
            >
              🏛️ Gujarat
            </button>
            <button
              onClick={() => window.navigateToRegion("mumbai")}
              style={{
                background: "#007bff",
                color: "white",
                border: "none",
                padding: "10px 20px",
                borderRadius: "6px",
                cursor: "pointer",
                fontWeight: "500",
                fontSize: "14px",
                transition: "all 0.3s ease",
              }}
              onMouseOver={(e) => (e.target.style.background = "#0056b3")}
              onMouseOut={(e) => (e.target.style.background = "#007bff")}
            >
              🏙️ Mumbai
            </button>
            <button
              onClick={() => window.navigateToRegion("nagpur")}
              style={{
                background: "#ffc107",
                color: "#212529",
                border: "none",
                padding: "10px 20px",
                borderRadius: "6px",
                cursor: "pointer",
                fontWeight: "500",
                fontSize: "14px",
                transition: "all 0.3s ease",
              }}
              onMouseOver={(e) => (e.target.style.background = "#e0a800")}
              onMouseOut={(e) => (e.target.style.background = "#ffc107")}
            >
              🏛️ Nagpur
            </button>
            <button
              onClick={() => window.navigateToRegion("usa")}
              style={{
                background: "#dc3545",
                color: "white",
                border: "none",
                padding: "10px 20px",
                borderRadius: "6px",
                cursor: "pointer",
                fontWeight: "500",
                fontSize: "14px",
                transition: "all 0.3s ease",
              }}
              onMouseOver={(e) => (e.target.style.background = "#c82333")}
              onMouseOut={(e) => (e.target.style.background = "#dc3545")}
            >
              🇺🇸 USA
            </button>
            <button
              onClick={() => window.navigateToRegion("canada")}
              style={{
                background: "#6f42c1",
                color: "white",
                border: "none",
                padding: "10px 20px",
                borderRadius: "6px",
                cursor: "pointer",
                fontWeight: "500",
                fontSize: "14px",
                transition: "all 0.3s ease",
              }}
              onMouseOver={(e) => (e.target.style.background = "#5a32a3")}
              onMouseOut={(e) => (e.target.style.background = "#6f42c1")}
            >
              🇨🇦 Canada
            </button>
            <button
              onClick={() => window.navigateToRegion("uk")}
              style={{
                background: "#fd7e14",
                color: "white",
                border: "none",
                padding: "10px 20px",
                borderRadius: "6px",
                cursor: "pointer",
                fontWeight: "500",
                fontSize: "14px",
                transition: "all 0.3s ease",
              }}
              onMouseOver={(e) => (e.target.style.background = "#e8650e")}
              onMouseOut={(e) => (e.target.style.background = "#fd7e14")}
            >
              🇬🇧 UK/Europe
            </button>
            <button
              onClick={() => window.navigateToRegion("all")}
              style={{
                background: "#6c757d",
                color: "white",
                border: "none",
                padding: "10px 20px",
                borderRadius: "6px",
                cursor: "pointer",
                fontWeight: "500",
                fontSize: "14px",
                transition: "all 0.3s ease",
              }}
              onMouseOver={(e) => (e.target.style.background = "#545b62")}
              onMouseOut={(e) => (e.target.style.background = "#6c757d")}
            >
              🌍 View All
            </button>
          </div>
        </div>

        <div id="loading-indicator" className="loading-indicator">
          Loading map...
        </div>
        <div id="map" className="map"></div>

        {/* React YouTube Video Modal */}
        {isVideoModalOpen && (
          <div
            className="modal"
            style={{
              display: "block",
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              background: "rgba(0,0,0,0.5)",
              zIndex: 9999,
            }}
          >
            <div
              className="modal-content"
              style={{
                width: "95%",
                maxWidth: "var(--popup-max-width)",
                maxHeight: "90vh",
                margin: "40px auto",
                background: "#fff",
                borderRadius: "8px",
                overflow: "hidden",
                position: "relative",
              }}
            >
              <button
                className="modal-close"
                aria-label="Close videos"
                style={{
                  position: "absolute",
                  top: 10,
                  right: 10,
                  fontSize: "2rem",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  zIndex: 1000,
                }}
                onClick={closeVideoModal}
              >
                &times;
              </button>
              <div className="modal-body" style={{ padding: 0 }}>
                {/* Show thumbnails if no video selected */}
                {!selectedVideoId && videoList.length > 0 && (
                  <div className="video-thumbnail-grid">
                    {videoList.map((video) => (
                      <div
                        key={video.id || video.youtubeId}
                        style={{ cursor: "pointer", textAlign: "left" }}
                        onClick={() => openVideoModal(video.youtubeId)}
                      >
                        <img
                          src={`https://img.youtube.com/vi/${video.youtubeId}/hqdefault.jpg`}
                          alt={video.title || "Video"}
                          style={{
                            width: "100%",
                            borderRadius: "8px",
                            marginBottom: "8px",
                            textAlign: "left",
                          }}
                        />
                        <div className="map-video-title" style={{ fontWeight: "bold", color: "#333" }}>
                          {video.title || "Video"}
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                {/* Show video player if video selected */}
                <VideoModal
                  videoId={selectedVideoId}
                  isOpen={!!selectedVideoId}
                  onClose={closeVideoModal}
                  title={
                    videoList.find((v) => v.youtubeId === selectedVideoId)
                      ?.title || "Video"
                  }
                />
                {/* Show loading or no videos message */}
                {!selectedVideoId && (
                  <>
                    {isLoadingVideos ? (
                      <div
                        className="map-status"
                        style={{
                          padding: "40px",
                          textAlign: "center",
                          color: "#888",
                        }}
                      >
                        Data Loading...
                      </div>
                    ) : (
                      videoList.length === 0 && (
                        <div
                          className="map-status"
                          style={{
                            padding: "40px",
                            textAlign: "center",
                            color: "#888",
                          }}
                        >
                          No videos found for {selectedPradesh}
                        </div>
                      )
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </main>
  );
}

// All the map initialization and configuration code
let map;
let infoWindow;
const vadodaraLatLng = { lat: 22.3072, lng: 73.1812 };
const pradeshLocations = [];
const cityPolygonData = {};
let allData = [];
let sabhaLocations = [];

const cityGeoJsonConfig = {
  vadodara: {
    filePath: "/map/geojson/geojson/Vadodara-Surrounding.geojson",
    color: "#E3027A",
    opacity: 0.5,
    strokeColor: "#E3027A",
    pradeshName: "Hariswarup Pradesh",
    displayName: "Vadodara",
  },
  nadiad: {
    filePath: "/map/geojson/geojson/Nadiad-Taluka.geojson",
    color: "orange",
    opacity: 0.5,
    strokeColor: "orange",
    pradeshName: "Harisumiran Pradesh",
    displayName: "Nadiad",
  },
  bakrol: {
    filePath: "/map/geojson/geojson/Bakrol-VVN-Anand.geojson",
    color: "orange",
    opacity: 0.7,
    strokeColor: "orange",
    pradeshName: "Harisumiran Pradesh",
    displayName: "Bakrol",
  },
  jambusartaluka: {
    filePath: "/map/geojson/geojson/Jambusar-Taluka.geojson",
    color: "#9CA352",
    opacity: 0.5,
    strokeColor: "#9CA352",
    pradeshName: "Hariakshar Pradesh",
    displayName: "Jambusar Taluka",
  },
  padrataluka: {
    filePath: "/map/geojson/geojson/Padra-Taluka.geojson",
    color: "#9CA352",
    opacity: 0.5,
    strokeColor: "#9CA352",
    pradeshName: "Hariakshar Pradesh",
    displayName: "Padra Taluka",
  },
  dabhoitaluka: {
    filePath: "/map/geojson/geojson/Dabhoi-Taluka.geojson",
    color: "#52A384",
    opacity: 0.5,
    strokeColor: "#52A384",
    pradeshName: "Haripriy Pradesh",
    displayName: "Dabhoi Taluka",
  },
  chhotaudepurtaluka: {
    filePath: "/map/geojson/geojson/Chootaudepur-Taluka.geojson",
    color: "#52A384",
    opacity: 0.5,
    strokeColor: "#52A384",
    pradeshName: "Haripriy Pradesh",
    displayName: "Chhota Udepur Taluka",
  },
  nasvaditaluka: {
    filePath: "/map/geojson/geojson/Nasvadi-Taluka.geojson",
    color: "#52A384",
    opacity: 0.5,
    strokeColor: "#52A384",
    pradeshName: "Haripriy Pradesh",
    displayName: "Nasvadi Taluka",
  },
  kavattaluka: {
    filePath: "/map/geojson/geojson/Kavat-Taluka.geojson",
    color: "#52A384",
    opacity: 0.5,
    strokeColor: "#52A384",
    pradeshName: "Haripriy Pradesh",
    displayName: "Kavat Taluka",
  },
  amodtaluka: {
    filePath: "/map/geojson/geojson/Amod-Taluka.geojson",
    color: "#A35252",
    opacity: 0.7,
    strokeColor: "#A35252",
    pradeshName: "Harimanan Pradesh",
    displayName: "Amod Taluka",
  },
  karjantaluka: {
    filePath: "/map/geojson/geojson/Karjan-Taluka.geojson",
    color: "#A35252",
    opacity: 0.7,
    strokeColor: "#A35252",
    pradeshName: "Harimanan Pradesh",
    displayName: "Karjan Taluka",
  },
  sinortaluka: {
    filePath: "/map/geojson/geojson/Sinor-Taluka.geojson",
    color: "#A35252",
    opacity: 0.7,
    strokeColor: "#A35252",
    pradeshName: "Harimanan Pradesh",
    displayName: "Sinor Taluka",
  },
  vagrataluka: {
    filePath: "/map/geojson/geojson/Vagra-Taluka.geojson",
    color: "#A35252",
    opacity: 0.7,
    strokeColor: "#A35252",
    pradeshName: "Harimanan Pradesh",
    displayName: "Vagra Taluka",
  },
  por: {
    filePath: "/map/geojson/geojson/Por.geojson",
    color: "#A35252",
    opacity: 0.7,
    strokeColor: "#A35252",
    pradeshName: "Harimanan Pradesh",
    displayName: "Por",
  },
  junagadhtaluka: {
    filePath: "/map/geojson/geojson/Junagadh-Taluka.geojson",
    color: "yellow",
    opacity: 0.7,
    strokeColor: "yellow",
    pradeshName: "Hariashray Pradesh",
    displayName: "Junagadh Taluka",
  },
  keshodtaluka: {
    filePath: "/map/geojson/geojson/Keshod-Taluka.geojson",
    color: "yellow",
    opacity: 0.7,
    strokeColor: "yellow",
    pradeshName: "Hariashray Pradesh",
    displayName: "Keshod Taluka",
  },
  manavadartaluka: {
    filePath: "/map/geojson/geojson/Manavadar-Taluka.geojson",
    color: "yellow",
    opacity: 0.7,
    strokeColor: "yellow",
    pradeshName: "Hariashray Pradesh",
    displayName: "Manavadar Taluka",
  },
  dhorajitaluka: {
    filePath: "/map/geojson/geojson/Dhoraji-Taluka.geojson",
    color: "yellow",
    opacity: 0.7,
    strokeColor: "yellow",
    pradeshName: "Hariashray Pradesh",
    displayName: "Dhoraji Taluka",
  },
  upletataluka: {
    filePath: "/map/geojson/geojson/Upleta-Taluka.geojson",
    color: "yellow",
    opacity: 0.7,
    strokeColor: "yellow",
    pradeshName: "Hariashray Pradesh",
    displayName: "Upleta Taluka",
  },
  vanthalitaluka: {
    filePath: "/map/geojson/geojson/Vanthali-Taluka.geojson",
    color: "yellow",
    opacity: 0.7,
    strokeColor: "yellow",
    pradeshName: "Hariashray Pradesh",
    displayName: "Vanthali Taluka",
  },
  bhavnagar: {
    filePath: "/map/geojson/geojson/Bhavnagar.geojson",
    color: "yellow",
    opacity: 0.7,
    strokeColor: "yellow",
    pradeshName: "Hariashray Pradesh",
    displayName: "Bhavnagar",
  },
  vadhavan: {
    filePath: "/map/geojson/geojson/Vadhavan.geojson",
    color: "yellow",
    opacity: 0.7,
    strokeColor: "yellow",
    pradeshName: "Hariashray Pradesh",
    displayName: "Vadhavan",
  },
  rajkottaluka: {
    filePath: "/map/geojson/geojson/Rajkot-Taluka.geojson",
    color: "blue",
    opacity: 0.5,
    strokeColor: "blue",
    pradeshName: "Hariamrut Pradesh",
    displayName: "Rajkot Taluka",
  },
  jasdantaluka: {
    filePath: "/map/geojson/geojson/Jasdan-Taluka.geojson",
    color: "blue",
    opacity: 0.5,
    strokeColor: "blue",
    pradeshName: "Hariamrut Pradesh",
    displayName: "Jasdan Taluka",
  },
  jamnagartaluka: {
    filePath: "/map/geojson/geojson/Jamnagar-Taluka.geojson",
    color: "blue",
    opacity: 0.5,
    strokeColor: "blue",
    pradeshName: "Hariamrut Pradesh",
    displayName: "Jamnagar Taluka",
  },
  morbitaluka: {
    filePath: "/map/geojson/geojson/Morbi-Taluka.geojson",
    color: "blue",
    opacity: 0.5,
    strokeColor: "blue",
    pradeshName: "Hariamrut Pradesh",
    displayName: "Morbi Taluka",
  },
  bhujtaluka: {
    filePath: "/map/geojson/geojson/Bhuj-Taluka.geojson",
    color: "red",
    opacity: 0.5,
    strokeColor: "red",
    pradeshName: "Hariprerit Pradesh",
    displayName: "Bhuj Taluka",
  },
  anjartaluka: {
    filePath: "/map/geojson/geojson/Anjar-Taluka.geojson",
    color: "red",
    opacity: 0.5,
    strokeColor: "red",
    pradeshName: "Hariprerit Pradesh",
    displayName: "Anjar Taluka",
  },
  mandavitaluka: {
    filePath: "/map/geojson/geojson/Mandavi-Taluka.geojson",
    color: "red",
    opacity: 0.5,
    strokeColor: "red",
    pradeshName: "Hariprerit Pradesh",
    displayName: "Mandavi Taluka",
  },
  gandhidham: {
    filePath: "/map/geojson/geojson/Gandhidham.geojson",
    color: "red",
    opacity: 0.5,
    strokeColor: "red",
    pradeshName: "Hariprerit Pradesh",
    displayName: "Gandhidham",
  },
  kaditaluka: {
    filePath: "/map/geojson/geojson/Kadi-Taluka.geojson",
    color: "green",
    opacity: 0.5,
    strokeColor: "green",
    pradeshName: "Haribhakti Pradesh",
    displayName: "Kadi Taluka",
  },
  mehsanataluka: {
    filePath: "/map/geojson/geojson/Mehsana-Taluka.geojson",
    color: "green",
    opacity: 0.5,
    strokeColor: "green",
    pradeshName: "Haribhakti Pradesh",
    displayName: "Mehsana Taluka",
  },
  patantaluka: {
    filePath: "/map/geojson/geojson/Patan-Taluka.geojson",
    color: "green",
    opacity: 0.5,
    strokeColor: "green",
    pradeshName: "Haribhakti Pradesh",
    displayName: "Patan Taluka",
  },
  unjhataluka: {
    filePath: "/map/geojson/geojson/Unjha-Taluka.geojson",
    color: "green",
    opacity: 0.5,
    strokeColor: "green",
    pradeshName: "Haribhakti Pradesh",
    displayName: "Unjha Taluka",
  },
  palanpurtaluka: {
    filePath: "/map/geojson/geojson/Palanpur-Taluka.geojson",
    color: "green",
    opacity: 0.5,
    strokeColor: "green",
    pradeshName: "Haribhakti Pradesh",
    displayName: "Palanpur Taluka",
  },
  amadavadtaluka: {
    filePath: "/map/geojson/geojson/Amadavad-Taluka.geojson",
    color: "#00BBF5",
    opacity: 0.6,
    strokeColor: "#00BBF5",
    pradeshName: "Harimay Pradesh",
    displayName: "Amadavad Taluka",
  },
  gandhinagartaluka: {
    filePath: "/map/geojson/geojson/Gandhinagar-Taluka.geojson",
    color: "#00BBF5",
    opacity: 0.6,
    strokeColor: "#00BBF5",
    pradeshName: "Harimay Pradesh",
    displayName: "Gandhinagar Taluka",
  },
  amadavad: {
    filePath: "/map/geojson/geojson/Amadavad-City.geojson",
    color: "#00BBF5",
    opacity: 0.6,
    strokeColor: "#00BBF5",
    pradeshName: "Harimay Pradesh",
    displayName: "Amadavad City",
  },
  savalitaluka: {
    filePath: "/map/geojson/geojson/Savali-Taluka.geojson",
    color: "#67A0DB",
    opacity: 0.6,
    strokeColor: "#67A0DB",
    pradeshName: "Haridarshan Pradesh",
    displayName: "Savali Taluka",
  },
  haloltaluka: {
    filePath: "/map/geojson/geojson/Halol-Taluka.geojson",
    color: "#67A0DB",
    opacity: 0.6,
    strokeColor: "#67A0DB",
    pradeshName: "Haridarshan Pradesh",
    displayName: "Halol Taluka",
  },
  godharataluka: {
    filePath: "/map/geojson/geojson/Godhara-Taluka.geojson",
    color: "#67A0DB",
    opacity: 0.6,
    strokeColor: "#67A0DB",
    pradeshName: "Haridarshan Pradesh",
    displayName: "Godhara Taluka",
  },
  sokhada: {
    filePath: "/map/geojson/geojson/Sokhada.geojson",
    color: "#67A0DB",
    opacity: 0.6,
    strokeColor: "#67A0DB",
    pradeshName: "Haridarshan Pradesh",
    displayName: "Sokhada",
  },
  asoj: {
    filePath: "/map/geojson/geojson/Asoj.geojson",
    color: "#67A0DB",
    opacity: 0.6,
    strokeColor: "#67A0DB",
    pradeshName: "Haridarshan Pradesh",
    displayName: "Asoj",
  },
  virod: {
    filePath: "/map/geojson/geojson/Virod.geojson",
    color: "#67A0DB",
    opacity: 0.6,
    strokeColor: "#67A0DB",
    pradeshName: "Haridarshan Pradesh",
    displayName: "Virod",
  },
  bhaniyara: {
    filePath: "/map/geojson/geojson/Bhaniyara.geojson",
    color: "#67A0DB",
    opacity: 0.6,
    strokeColor: "#67A0DB",
    pradeshName: "Haridarshan Pradesh",
    displayName: "Bhaniyara",
  },
  ganeshpura: {
    filePath: "/map/geojson/geojson/Ganeshpura.geojson",
    color: "#67A0DB",
    opacity: 0.9,
    strokeColor: "#67A0DB",
    pradeshName: "Haridarshan Pradesh",
    displayName: "Ganeshpura",
  },
  bharuchtaluka: {
    filePath: "/map/geojson/geojson/Bharuch-Taluka.geojson",
    color: "#DB4A2E",
    opacity: 0.5,
    strokeColor: "#DB4A2E",
    pradeshName: "Harisanmukh Pradesh",
    displayName: "Bharuch Taluka",
  },
  ankleshwartalula: {
    filePath: "/map/geojson/geojson/Ankleshwar-Taluka.geojson",
    color: "#DB4A2E",
    opacity: 0.5,
    strokeColor: "#DB4A2E",
    pradeshName: "Harisanmukh Pradesh",
    displayName: "Ankleshwar Taluka",
  },
  kamrejtaluka: {
    filePath: "/map/geojson/geojson/Kamrej-Taluka.geojson",
    color: "#A3529F",
    opacity: 0.5,
    strokeColor: "#A3529F",
    pradeshName: "Harichintan Pradesh",
    displayName: "Kamrej Taluka",
  },
  olpadtaluka: {
    filePath: "/map/geojson/geojson/Olpad-Taluka.geojson",
    color: "#A3529F",
    opacity: 0.5,
    strokeColor: "#A3529F",
    pradeshName: "Harichintan Pradesh",
    displayName: "Olpad Taluka",
  },
  mangroltaluka: {
    filePath: "/map/geojson/geojson/Mangrol-Taluka.geojson",
    color: "#A3529F",
    opacity: 0.5,
    strokeColor: "#A3529F",
    pradeshName: "Harichintan Pradesh",
    displayName: "Mangrol Taluka",
  },
  surat: {
    filePath: "/map/geojson/geojson/Surat-City.geojson",
    color: "#1CADAD",
    opacity: 0.5,
    strokeColor: "#1CADAD",
    pradeshName: "Harinaman Pradesh",
    displayName: "Surat City",
  },
  jalalportaluka: {
    filePath: "/map/geojson/geojson/Jalalpor-Taluka.geojson",
    color: "#1CADAD",
    opacity: 0.5,
    strokeColor: "#1CADAD",
    pradeshName: "Harinaman Pradesh",
    displayName: "Jalalpor Taluka",
  },
  gandevitaluka: {
    filePath: "/map/geojson/geojson/Gandevi-Taluka.geojson",
    color: "#64E302",
    opacity: 0.5,
    strokeColor: "#64E302",
    pradeshName: "Haricharan Pradesh",
    displayName: "Gandevi Taluka",
  },
  valsadtaluka: {
    filePath: "/map/geojson/geojson/Valsad-Taluka.geojson",
    color: "#64E302",
    opacity: 0.5,
    strokeColor: "#64E302",
    pradeshName: "Haricharan Pradesh",
    displayName: "Valsad Taluka",
  },
  vapitaluka: {
    filePath: "/map/geojson/geojson/Vapi-Taluka.geojson",
    color: "#64E302",
    opacity: 0.5,
    strokeColor: "#64E302",
    pradeshName: "Haricharan Pradesh",
    displayName: "Vapi Taluka",
  },
  umargamtaluka: {
    filePath: "/map/geojson/geojson/Umargam-Taluka.geojson",
    color: "#64E302",
    opacity: 0.5,
    strokeColor: "#64E302",
    pradeshName: "Haricharan Pradesh",
    displayName: "Umargam Taluka",
  },
  mumbai: {
    filePath: "/map/geojson/geojson/Mumbai-District.geojson",
    color: "#5952A3",
    opacity: 0.5,
    strokeColor: "#5952A3",
    pradeshName: "Harihraday Pradesh",
    displayName: "Mumbai District",
  },
  petladtaluka: {
    filePath: "/map/geojson/geojson/Petlad-Taluka.geojson",
    color: "#18DBD7",
    opacity: 0.6,
    strokeColor: "#18DBD7",
    pradeshName: "Haritanay Pradesh",
    displayName: "Petlad Taluka",
  },
  thasrataluka: {
    filePath: "/map/geojson/geojson/Thasra-Taluka.geojson",
    color: "#18DBD7",
    opacity: 0.6,
    strokeColor: "#18DBD7",
    pradeshName: "Haritanay Pradesh",
    displayName: "Thasra Taluka",
  },
  kapadvanjtaluka: {
    filePath: "/map/geojson/geojson/Kapadvanj-Taluka.geojson",
    color: "#18DBD7",
    opacity: 0.6,
    strokeColor: "#18DBD7",
    pradeshName: "Haritanay Pradesh",
    displayName: "Kapadvanj Taluka",
  },
  balasinortaluka: {
    filePath: "/map/geojson/geojson/Balasinor-Taluka.geojson",
    color: "#18DBD7",
    opacity: 0.6,
    strokeColor: "#18DBD7",
    pradeshName: "Haritanay Pradesh",
    displayName: "Balasinor Taluka",
  },
  borsadtaluka: {
    filePath: "/map/geojson/geojson/Borsad-Taluka.geojson",
    color: "#18DBD7",
    opacity: 0.6,
    strokeColor: "#18DBD7",
    pradeshName: "Haritanay Pradesh",
    displayName: "Borsad Taluka",
  },
  anklavtaluka: {
    filePath: "/map/geojson/geojson/Anklav-Taluka.geojson",
    color: "#18DBD7",
    opacity: 0.6,
    strokeColor: "#18DBD7",
    pradeshName: "Haritanay Pradesh",
    displayName: "Anklav Taluka",
  },
  nagpur: {
    filePath: "/map/geojson/geojson/Nagpur.geojson",
    color: "#DB0263",
    opacity: 0.6,
    strokeColor: "#DB0263",
    pradeshName: "Harisharan Pradesh",
    displayName: "Nagpur",
  },
  bhopal: {
    filePath: "/map/geojson/geojson/Bhopal.geojson",
    color: "#DB0263",
    opacity: 0.6,
    strokeColor: "#DB0263",
    pradeshName: "Harisharan Pradesh",
    displayName: "Bhopal",
  },
  bengaluru: {
    filePath: "/map/geojson/geojson/Bengaluru.geojson",
    color: "#DB0263",
    opacity: 0.6,
    strokeColor: "#DB0263",
    pradeshName: "Harisharan Pradesh",
    displayName: "Bengaluru",
  },
  itarsi: {
    filePath: "/map/geojson/geojson/Itarsi-MP.geojson",
    color: "#DB0263",
    opacity: 0.6,
    strokeColor: "#DB0263",
    pradeshName: "Harisharan Pradesh",
    displayName: "Itarsi",
  },
  bhadohi: {
    filePath: "/map/geojson/geojson/Bhadohi-UP.geojson",
    color: "#DB0263",
    opacity: 0.6,
    strokeColor: "#DB0263",
    pradeshName: "Harisharan Pradesh",
    displayName: "Bhadohi",
  },
  moga: {
    filePath: "/map/geojson/geojson/Moga-Punjab.geojson",
    color: "#DB0263",
    opacity: 0.6,
    strokeColor: "#DB0263",
    pradeshName: "Harisharan Pradesh",
    displayName: "Moga",
  },
};

function initMap() {
  // Safety check: ensure Google Maps API is loaded
  if (!window.google || !window.google.maps) {
    console.error("Google Maps API not loaded yet");
    showLoading(false);
    return;
  }

  // Check if map container exists
  const mapContainer = document.getElementById("map");
  if (!mapContainer) {
    console.error("Map container not found");
    showLoading(false);
    return;
  }

  try {
    map = new window.google.maps.Map(mapContainer, {
      center: vadodaraLatLng,
      zoom: 8,
    });

    infoWindow = new window.google.maps.InfoWindow();
    showLoading(true);

    Promise.all([fetchPradeshLocations(), loadAllGeoJsonPolygons()])
      .then(() => {
        addMarkersToMap();
        showLoading(false);
        console.log("Map and data loaded.");

        map.data.setStyle(function (feature) {
          const cityKey = feature.getProperty("cityKey");
          const config = cityPolygonData[cityKey];

          if (config) {
            return {
              fillColor: config.color,
              fillOpacity: config.opacity,
              strokeColor: config.strokeColor,
              strokeWeight: 2,
            };
          }

          return {
            fillColor: "#cccccc",
            fillOpacity: 0.3,
            strokeColor: "#666666",
            strokeWeight: 1,
          };
        });

        map.data.addListener("click", function (event) {
          const cityKey = event.feature.getProperty("cityKey");
          const config = cityPolygonData[cityKey];

          if (!config) return;

          const content = `
          <div class="map-info-content" style="
            font-family: Arial, sans-serif;
            padding: 10px;
            max-width: 220px;
            line-height: 1.5;
          ">
            <p style="margin: 0; font-weight: bold; color: #333;">${config.cityName}</p>
            <p style="margin: 0; font-weight: bold; color: #333;">${config.pradeshName}</p>
            <p style="margin-top: 8px;">
            
            <button id="viewVideosBtn_${config.pradeshName}"
  style="background: #007BFF; color: white; border: none; padding: 8px 16px; border-radius: 4px; cursor: pointer; display: flex; align-items: center;">
  <i class="fab fa-youtube" style="margin-right: 6px;"></i> View Videos
</button>

            </p>
          </div>
        `;

          infoWindow.setContent(content);
          infoWindow.setPosition(event.latLng);
          infoWindow.open(map);
          window.setTimeout(() => {
            const btn = document.getElementById(
              `viewVideosBtn_${config.pradeshName}`,
            );
            if (btn) {
              btn.addEventListener("click", () => {
                window.dispatchEvent(
                  new CustomEvent("openPradeshModal", {
                    detail: { pradeshName: config.pradeshName },
                  }),
                );
              });
            }
          }, 0);
        });
      })
      .catch((error) => {
        console.error("Error loading map data:", error);
        showLoading(false);
        alert("Could not load map data. Please try again later.");
      });

    /*Promise.all([fetchSabhaLocations()])
      .then(() => {
        showLoading(false);
        console.log("Sabha data loaded.");
      })
      .catch((error) => {
        console.error("Error loading Sabha data:", error);
        showLoading(false);
      });
     */
  } catch (error) {
    console.error("Error initializing map:", error);
    showLoading(false);
    alert("Failed to initialize map. Please refresh the page and try again.");
  }
}

function showLoading(isLoading) {
  const loadingIndicator = document.getElementById("loading-indicator");
  if (loadingIndicator) {
    loadingIndicator.style.display = isLoading ? "block" : "none";
  }
}

async function fetchPradeshLocations() {
  try {
    const staticLocations = [
      {
        id: 1,
        latitude: "22.5577306",
        longitude: "72.9181045",
        pradeshName: "Harisumiran Pradesh",
        title: "Harisumiran Pradesh Pin",
      },
      {
        id: 2,
        latitude: "22.483614",
        longitude: "72.801351",
        pradeshName: "Haritanay Pradesh",
        title: "Haritanay Pradesh Pin",
      },
      {
        id: 3,
        latitude: "22.321806",
        longitude: "73.132332",
        pradeshName: "Hariswarup Pradesh",
        title: "Hariswarup Pradesh Pin",
      },
      {
        id: 4,
        latitude: "22.0534997",
        longitude: "73.1201988",
        pradeshName: "Harimanan Pradesh",
        title: "Harimanan Pradesh Pin",
      },
      {
        id: 5,
        latitude: "21.715199",
        longitude: "73.036162",
        pradeshName: "Harisanmukh Pradesh",
        title: "Harisanmukh Pradesh Pin",
      },
      {
        id: 6,
        latitude: "21.26774",
        longitude: "73.00809",
        pradeshName: "Harichintan Pradesh",
        title: "Harichintan Pradesh Pin",
      },
      {
        id: 7,
        latitude: "21.17675",
        longitude: "72.80112",
        pradeshName: "Harinaman Pradesh",
        title: "Harinaman Pradesh Pin",
      },
      {
        id: 8,
        latitude: "20.80767",
        longitude: "72.9992",
        pradeshName: "Haricharan Pradesh",
        title: "Haricharan Pradesh Pin",
      },
      {
        id: 9,
        latitude: "22.41049",
        longitude: "73.191863",
        pradeshName: "Haridarshan Pradesh",
        title: "Haridarshan Pradesh Pin",
      },
      {
        id: 10,
        latitude: "22.05004",
        longitude: "72.79212",
        pradeshName: "Hariakshar Pradesh",
        title: "Hariakshar Pradesh Pin",
      },
      {
        id: 11,
        latitude: "22.063466",
        longitude: "73.345854",
        pradeshName: "Haripriy Pradesh",
        title: "Haripriy Pradesh Pin",
      },
      {
        id: 12,
        latitude: "23.0225",
        longitude: "72.57136",
        pradeshName: "Harimay Pradesh",
        title: "Harimay Pradesh Pin",
      },
      {
        id: 13,
        latitude: "23.85001",
        longitude: "72.12102",
        pradeshName: "Haribhakti Pradesh",
        title: "Haribhakti Pradesh Pin",
      },
      {
        id: 14,
        latitude: "22.27361",
        longitude: "70.72667",
        pradeshName: "Hariamrut Pradesh",
        title: "Hariamrut Pradesh Pin",
      },
      {
        id: 15,
        latitude: "23.2725783",
        longitude: "69.6035821",
        pradeshName: "Hariprerit Pradesh",
        title: "Hariprerit Pradesh Pin",
      },
      {
        id: 16,
        latitude: "21.52752",
        longitude: "70.49095",
        pradeshName: "Hariashray Pradesh",
        title: "Hariashray Pradesh Pin",
      },
      {
        id: 17,
        latitude: "19.1075424",
        longitude: "72.8263142",
        pradeshName: "Harihraday Pradesh",
        title: "Harihraday Pradesh Pin",
      },
      {
        id: 18,
        latitude: "21.139358",
        longitude: "79.1379894",
        pradeshName: "Harisharan Pradesh",
        title: "Harisharan Pradesh Pin",
      },
      {
        id: 19,
        latitude: "40.87739",
        longitude: "-74.38537",
        pradeshName: "USA",
        title: "USA Pin",
      },
      {
        id: 20,
        latitude: "43.7103819",
        longitude: "-79.6380477",
        pradeshName: "Canada",
        title: "Canada Pin",
      },
      {
        id: 21,
        latitude: "51.58215",
        longitude: "-0.30602",
        pradeshName: "Europe",
        title: "Europe Pin",
      },
      {
        id: 22,
        latitude: "-36.866554",
        longitude: "174.6305972",
        pradeshName: "NZUS",
        title: "NZUS Pin",
      },
    ];

    pradeshLocations.push(...staticLocations);
    console.log("Pradesh locations fetched/loaded:", pradeshLocations.length);
  } catch (error) {
    console.error("Could not fetch Pradesh locations:", error);
  }
}

async function fetchSabhaLocations() {
  try {
    const pradeshUrl = "/map/dbihariprabodhamlocation.php";

    const response = await fetch(pradeshUrl, {
      method: "GET",
      headers: {
        Origin: "",
        "X-Requested-With": "XMLHttpRequest",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      console.error(
        "Expected JSON but got:",
        contentType,
        "Response:",
        text.substring(0, 500),
      );
      throw new Error(`Expected JSON response but got: ${contentType}`);
    }

    const data = await response.json();
    sabhaLocations = data;
    addSabhaMarkersToMap();
    console.log("Sabha locations fetched/loaded:", sabhaLocations.length);
  } catch (error) {
    console.error("Could not fetch Sabha locations:", error);
    // Continue without Sabha locations if the API fails
    sabhaLocations = [];
  }
}

function addMarkersToMap() {
  pradeshLocations.forEach((location) => {
    if (location.latitude && location.longitude) {
      const lat = parseFloat(location.latitude);
      const lng = parseFloat(location.longitude);

      if (!isNaN(lat) && !isNaN(lng)) {
        const marker = new window.google.maps.Marker({
          position: { lat: lat, lng: lng },
          map: map,
          title: location.title || location.pradeshName,
          icon: {
            url: "/map/pinimage/pin-orange.png",
            scaledSize: new window.google.maps.Size(18, 29),
          },
        });

        marker.addListener("click", () => {
          infoWindow.setContent(`
            <div class="info-content map-info-content" style="
              font-family: Arial, sans-serif;
              padding: 10px;
              max-width: 220px;
              line-height: 1.5;
            ">
              <p style="margin: 0; font-weight: bold; color: #333;">${location.pradeshName}</p>
              <p style="margin-top: 8px;">
               <button id="viewVideosBtn_${location.pradeshName}"
  style="background: #007BFF; color: white; border: none; padding: 8px 16px; border-radius: 4px; cursor: pointer; display: flex; align-items: center;">
  <i class="fab fa-youtube" style="margin-right: 6px;"></i> View Videos
</button>
              </p>
            </div>
          `);

          infoWindow.open(map, marker);
          window.setTimeout(() => {
            const btn = document.getElementById(
              `viewVideosBtn_${location.pradeshName}`,
            );
            if (btn) {
              btn.addEventListener("click", () => {
                window.dispatchEvent(
                  new CustomEvent("openPradeshModal", {
                    detail: { pradeshName: location.pradeshName },
                  }),
                );
              });
            }
          }, 0);
          console.log(`Marker clicked for Pradesh: ${location.pradeshName}`);
        });
      }
    }
  });
}

function addSabhaMarkersToMap() {
  sabhaLocations.forEach((location) => {
    if (location.Latitude && location.Longitude) {
      const lat = parseFloat(location.Latitude);
      const lng = parseFloat(location.Longitude);

      if (!isNaN(lat) && !isNaN(lng)) {
        const marker = new window.google.maps.Marker({
          position: { lat: lat, lng: lng },
          map: map,
          title: location.Title || location.Pradesh,
          icon: {
            url: "/map/pinimage/pinwithplay.png",
            scaledSize: new window.google.maps.Size(30, 30),
          },
        });

        marker.addListener("click", () => {
          infoWindow.setContent(`
            <div class="info-content map-info-content" style="
              font-family: Arial, sans-serif;
              padding: 10px;
              max-width: 300px;
              line-height: 1.5;
            ">
              <p style="margin: 0; font-weight: bold; color: #333;">${location.City}</p>
              <p style="margin: 0; font-weight: bold; color: #333;">${location.Pradesh}</p>
              <div style="margin-top: 10px;">
                <iframe width="100%" height="180" 
                  src="https://www.youtube.com/embed/${extractYouTubeId(location.VideoUrl)}" 
                  frameborder="0" 
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                  allowfullscreen>
                </iframe>
              </div>
            </div>
          `);

          infoWindow.open(map, marker);
          console.log(`Marker clicked for Pradesh: ${location.Pradesh}`);
        });
      }
    }
  });
}

function extractYouTubeId(url) {
  const regExp = /^.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#\&\?]*).*/;
  const match = url.match(regExp);
  return match && match[1].length === 11 ? match[1] : null;
}

async function loadAllGeoJsonPolygons() {
  const polygonPromises = [];
  for (const cityKey in cityGeoJsonConfig) {
    const config = cityGeoJsonConfig[cityKey];
    polygonPromises.push(loadSingleGeoJson(cityKey, config));
  }
  await Promise.all(polygonPromises);
  console.log("All GeoJSON polygons processed.");
}

async function loadSingleGeoJson(cityKey, config) {
  try {
    const response = await fetch(config.filePath);
    if (!response.ok) {
      throw new Error(
        `HTTP error! status: ${response.status} for ${config.filePath}`,
      );
    }
    const geoJsonData = await response.json();
    console.log(`Loaded GeoJSON for ${cityKey}`);

    geoJsonData.features.forEach((feature) => {
      feature.properties.cityKey = cityKey;
    });

    map.data.addGeoJson(geoJsonData);

    cityPolygonData[cityKey] = {
      cityName: config.displayName,
      pradeshName: config.pradeshName,
      color: config.color,
      opacity: config.opacity,
      strokeColor: config.strokeColor,
    };
  } catch (error) {
    console.error(`Error loading GeoJSON for ${cityKey}:`, error);
  }
}

// Navigation function for regional zoom
window.navigateToRegion = function (region) {
  if (!map) {
    console.error("Map not initialized yet");
    return;
  }

  const regionCoordinates = {
    gujarat: { lat: 22.5, lng: 72.5, zoom: 7 },
    mumbai: { lat: 19.1075424, lng: 72.8263142, zoom: 10 },
    nagpur: { lat: 21.139358, lng: 79.1379894, zoom: 10 },
    usa: { lat: 40.87739, lng: -74.38537, zoom: 6 },
    canada: { lat: 43.7103819, lng: -79.6380477, zoom: 6 },
    uk: { lat: 51.58215, lng: -0.30602, zoom: 6 },
    all: { lat: 22.3072, lng: 73.1812, zoom: 3 },
  };

  const coords = regionCoordinates[region];
  if (coords) {
    map.setCenter({ lat: coords.lat, lng: coords.lng });
    map.setZoom(coords.zoom);
    console.log(`Navigated to ${region}:`, coords);
  } else {
    console.error("Unknown region:", region);
  }
};

// Modal functions

// Pradesh Modal Close Function
window.closeModal = function () {
  const modal = document.getElementById("pradeshModal");
  modal.style.display = "none";
  document.body.style.overflow = "auto"; // Restore scrolling
};

// YouTube Modal Functions
window.openYouTubeModal = function (embedUrl) {
  if (!embedUrl) return;

  const modal = document.getElementById("youtubeModal");
  const youtubePlayer = document.getElementById("youtubePlayer");

  // Set the embed URL with autoplay
  youtubePlayer.src = `${embedUrl}?autoplay=1&rel=0`;

  // Show modal
  modal.style.display = "block";
  document.body.style.overflow = "hidden"; // Prevent background scrolling
};

window.closeYouTubeModal = function () {
  const modal = document.getElementById("youtubeModal");
  const youtubePlayer = document.getElementById("youtubePlayer");

  // Clear the video source to stop playback
  youtubePlayer.src = "";

  // Hide modal
  modal.style.display = "none";
  document.body.style.overflow = "auto"; // Restore scrolling
};

// Close modal when clicking outside
window.addEventListener("click", function (event) {
  const youtubeModal = document.getElementById("youtubeModal");
  const pradeshModal = document.getElementById("pradeshModal");

  if (event.target === youtubeModal) {
    window.closeYouTubeModal();
  }

  if (event.target === pradeshModal) {
    window.closeModal();
  }
});

// Close modal with Escape key
window.addEventListener("keydown", function (event) {
  if (event.key === "Escape") {
    const youtubeModal = document.getElementById("youtubeModal");
    const pradeshModal = document.getElementById("pradeshModal");

    if (youtubeModal && youtubeModal.style.display === "block") {
      window.closeYouTubeModal();
    }

    if (pradeshModal && pradeshModal.style.display === "block") {
      window.closeModal();
    }
  }
});

export default PradeshMap;
